//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export const ProductDetailsFieldLabels = {
  brand: 'Brand',
  category: 'Category',
  description: 'Description',
  destinationGTIN: 'GTINs/UPCs/EANs for Syndication',
  fairMarketValue: 'Full Market Value (FMV)',
  imgUrl: 'Product Image',
  logisticsRef: 'Unique Product Code',
  name: 'Name',
  pdpUrl: 'Product Display Page URL',
  quantity: 'Quantity',
  shippingAvailabilityDate: 'Shipping Availability Date',
  targetCatalogProductId: 'Product ID',
  variantName: 'Name',
} as const;
